import css from 'styled-jsx/css';

export default css`.slideUpModal.enter-active .slideUpModal__overlay, .slideUpModal.enter-done .slideUpModal__overlay {
  opacity: 1; }

.slideUpModal.enter-active .slideUpModal__modal, .slideUpModal.enter-done .slideUpModal__modal {
  transform: translate(-50%, 0); }
  @media (min-width: 576px) {
    .slideUpModal.enter-active .slideUpModal__modal, .slideUpModal.enter-done .slideUpModal__modal {
      bottom: 50%;
      transform: translate(-50%, 50%); } }

.slideUpModal .slideUpModal__overlay {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1001;
  opacity: 0;
  transition: opacity .4s; }

.slideUpModal .slideUpModal__modal {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
  width: 100%;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
  background-color: #efefef;
  z-index: 1002;
  transition: transform .2s, bottom .2s; }
  @media (min-width: 576px) {
    .slideUpModal .slideUpModal__modal {
      max-width: 400px;
      border-radius: 4px; } }
`